import type { Action } from 'state/actions';

import * as actionTypes from '../addonManagementForm.actionTypes';
import type { AddonManagementFormFiltersStateMap } from './filters.model';

export function filtersReducer(
  state: AddonManagementFormFiltersStateMap = { view: 'default' },
  action: Action,
): AddonManagementFormFiltersStateMap {
  if (action.type === actionTypes.ADDON_MANAGEMENT_FORM_VIEW_SELECTED) {
    return {
      ...state,
      view: action.view,
    };
  }
  return state;
}
